import {add} from "date-fns";

export const availableFromDates: Record<string, Date> = {
    now: new Date(),
    three_months: add(new Date(), {months: 3}),
    six_months: add(new Date(), {months: 6}),
    twelve_months: add(new Date(), {years: 1}),
    twenty_four_months: add(new Date(), {years: 2})
};
